module.exports = __webpack_public_path__ + "static/img/1.e8d8347.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/park/1.png
// module id = m0Pv
// module chunks = 0